<ion-content forceOverscroll="true">
  <div class="container">
    <div class="container-header">
      <ion-img [src]="'assets/images/logo/logo-4.png'"></ion-img>
    </div>
    <div class="footer-btn">
      <ion-button color="welcome-btn " (click)="navigateToLogin()"
        >ENTRAR</ion-button
      >
      <ion-button color="dark" (click)="navigateToSignup()"
        >Cadastre-se</ion-button
      >
    </div>
  </div>
</ion-content>
